import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  id: number;
  defaultLocationId?: number;
  trimId?: number;
};

type EarningsTier = {
  estimatedEarnings: number;
};

export type EarningsByMileage = Record<string, EarningsTier>;

export type CarSubscriptionEarnings = {
  weekly?: EarningsByMileage;
  monthly?: EarningsByMileage;
  '6Months'?: EarningsByMileage;
};

export const useCarSubscriptionEarnings = createQuery<
  CarSubscriptionEarnings,
  Variables,
  AxiosError
>({
  queryKey: ['car-subscription-earnings'],
  fetcher: (variables) => {
    return client
      .get(
        `v2/internal/partners/cars/${variables.id}/subscription-owner-earnings`,
        {
          params: {
            default_location_id: variables.defaultLocationId,
            trim_id: variables.trimId,
          },
        }
      )
      .then((response) => {
        return response.data.data;
      });
  },
});
